export default __webpack_public_path__ + "static/media/2017-baches-app.e2a878cb.png";